import Error from "@/components/common/Error/Error";
import { CSSProperties } from "react";
import { BiErrorCircle } from "react-icons/bi";
import { When } from "@/components/common/When";
type Props = {
  errors: string[] | null;
  parentStyle?: CSSProperties;
  withIcon?: boolean;
};
export function HomePageError({
  errors,
  parentStyle,
  withIcon = true
}: Props) {
  if (!errors) return null;
  return <div style={parentStyle} data-sentry-component="HomePageError" data-sentry-source-file="HomePageError.tsx">
      {errors.map(error => <Error key={error} mt={5}>
          <When condition={withIcon}>
            <BiErrorCircle color="#F25A29" size={16} />
          </When>
          {error}
        </Error>)}
    </div>;
}